import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/crm/appointments"; 
const apiFeedBackEndPoint=API_BASE_URL_ENV() + "/crm/feedbacks"; 
const statusApi=API_BASE_URL_ENV() + "/crm/toggle-status/Appointment/"
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
    addFeedback=(data)=>{
        return http.post(apiFeedBackEndPoint, data);
    }
    toggleStatus=(id,data)=>{
        return http.post(`${statusApi}${id}`,data);
     }
 
}
